import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import {
  TypeformCsatConfigurationResponse,
  ITypeformCsatGateway,
  TypeformCsatCampaign
} from "../gateways/TypeformCsatGateway";

@injectable()
export default class TypeformCsatGatewayAdapter implements ITypeformCsatGateway {
  @inject(DITypes.HORIZONS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async obterConfiguracaoJson(): Promise<TypeformCsatCampaign[] | undefined> {
    const response =
      await this.httpClient.get<TypeformCsatConfigurationResponse>({
        url: "/financas/PesquisaNPS/v1/obter-configuracao-json"
      });

    if (!response.body) return undefined;

    if (Array.isArray(response.body)) return response.body;

    return response.body.Result || response.body.result || [];
  }
}
